import { Component } from '@angular/core';
import { LoadingService } from '../../services/loading.service';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-loading',
    template: `
        <div *ngIf="loading$ | async" class="loading-overlay">
            <div class="loading-spinner"></div>
        </div>
    `,
    styleUrls: ['./loading.component.less'],
    standalone: true,
    imports: [NgIf, AsyncPipe],
})
export class LoadingComponent {
    loading$;

    constructor(private loadingService: LoadingService) {
        this.loading$ = this.loadingService.loading$;
    }
}
